import React, { type FC, useEffect, useRef, useState } from 'react';

import CircleQuestion from '@gravity-ui/icons/CircleQuestion';
import { Button, Icon, Popup } from '@gravity-ui/uikit';

import styles from './Hint.module.scss';

interface Props {
    hint: React.ReactNode;
}

export const Hint: FC<Props> = ({ hint }) => {
    const [isOpen, setIsOpen] = useState(false);
    const popupRef = useRef(null);

    useEffect(() => {
        let interval: ReturnType<typeof setInterval>;
        if (isOpen) {
            interval = setInterval(() => {
                if (popupRef && popupRef.current && document.activeElement !== popupRef.current) {
                    setIsOpen(false);
                }
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [isOpen]);

    return (
        <>
            <Button
                className={styles.hint__anchor}
                title={typeof hint === 'string' ? hint : undefined}
                onClick={() => setIsOpen((state) => !state)}
                ref={popupRef}
                size="xs"
                view="flat"
            >
                <Icon className={styles.hint__icon} data={CircleQuestion} />
            </Button>
            <Popup anchorRef={popupRef} open={isOpen}>
                <div className={styles.hint__content}>{hint}</div>
            </Popup>
        </>
    );
};
